import { PERMISSIONS } from '@helios/authz';
import { useQuery } from '@tanstack/react-query';
import { buildStatusClient } from '@/services/buildStatusClient';
import { sessionScopeKey, useSessionScopeFence } from './useSessionScope';
export function useBuildStatus() {
  const { identity, enabled, isCurrent } = useSessionScopeFence(PERMISSIONS.PLATFORM_ADMIN);
  const query = useQuery({ queryKey: ['engineering-bible', 'build-status', ...sessionScopeKey(identity)], enabled, placeholderData: () => undefined,
    queryFn: async ({ signal }) => { if (!isCurrent(identity)) throw new Error('Build status access required.'); const result = await buildStatusClient.getBuildStatus({ signal, sessionOrigin: identity.sessionOrigin }); signal.throwIfAborted(); if (!isCurrent(identity)) throw new Error('Build status access changed while loading.'); return result; },
    refetchInterval: 15_000, staleTime: 0, refetchOnMount: 'always', refetchOnWindowFocus: 'always', retry: false,
  });
  return { ...query, data: enabled && !query.isError ? query.data : undefined };
}
